/**
 * beamShoot.js — クリックビーム発射 + 蜂攻撃インタラクション
 */

const rand = (min, max) => Math.random() * (max - min) + min;
const PARTICLE_COLORS = ['#00d4ff', '#ffd700', '#ffffff', '#ff6b35', '#00ffaa'];

// ── ビーム発射（左下・右下 → カーソルへ収束）──────────────
const makeBeam = (fromX, fromY, toX, toY, colorRgb) => {
  const dx     = toX - fromX;
  const dy     = toY - fromY;
  const length = Math.hypot(dx, dy);
  const angle  = Math.atan2(dy, dx) * (180 / Math.PI);

  const beam = document.createElement('div');
  beam.className = 'c-beam';
  beam.style.cssText = `
    width: ${length}px;
    left: ${fromX}px;
    top: ${fromY - 1}px;
    transform: rotate(${angle}deg);
    transform-origin: left center;
    background: linear-gradient(to right, transparent 0%, rgba(${colorRgb}, 0.95) 100%);
  `;
  document.body.appendChild(beam);

  gsap.fromTo(
    beam,
    { scaleX: 0, opacity: 1 },
    {
      scaleX: 1,
      opacity: 0,
      duration: 0.42,
      ease: 'power2.out',
      onComplete: () => beam.remove(),
    }
  );
};

const shoot = (x, y) => {
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  // 左下 → カーソル（シアン）
  makeBeam(0, vh, x, y, '0, 212, 255');
  // 右下 → カーソル（ゴールド）
  makeBeam(vw, vh, x, y, '255, 215, 0');

  // カーソル位置にインパクトフラッシュ
  const flash = document.createElement('div');
  flash.className = 'c-beam-impact';
  flash.style.cssText = `left:${x - 20}px;top:${y - 20}px;`;
  document.body.appendChild(flash);
  gsap.to(flash, { opacity: 0, scale: 2.5, duration: 0.3, onComplete: () => flash.remove() });
};

// ── 蜂爆発 ──────────────────────────────────────────────────
const explode = (beeEl) => {
  const rect = beeEl.getBoundingClientRect();
  const cx = rect.left + rect.width  / 2;
  const cy = rect.top  + rect.height / 2;

  // パーティクル
  for (let i = 0; i < 14; i++) {
    const p = document.createElement('div');
    p.className = 'c-bee-particle';
    const size = rand(5, 14);
    p.style.cssText = `width:${size}px;height:${size}px;background:${
      PARTICLE_COLORS[Math.floor(rand(0, PARTICLE_COLORS.length))]
    };`;
    document.body.appendChild(p);

    gsap.set(p, { x: cx - size / 2, y: cy - size / 2 });
    gsap.to(p, {
      x: cx + rand(-160, 160),
      y: cy + rand(-160, 80),
      opacity: 0,
      scale: rand(0.2, 2.0),
      rotation: rand(0, 720),
      duration: rand(0.5, 1.1),
      ease: 'power2.out',
      onComplete: () => p.remove(),
    });
  }

  // フラッシュ
  const flash = document.createElement('div');
  flash.className = 'c-bee-flash';
  flash.style.cssText = `left:${cx - 40}px;top:${cy - 40}px;`;
  document.body.appendChild(flash);
  gsap.to(flash, { opacity: 0, scale: 3, duration: 0.4, onComplete: () => flash.remove() });

  // 蜂を消す
  gsap.to(beeEl, {
    scale: 2,
    opacity: 0,
    duration: 0.2,
    ease: 'power1.out',
    onComplete: () => {
      gsap.set(beeEl, { display: 'none', scale: 1, opacity: 1 });
      // 5秒後に復活イベントを発火
      setTimeout(() => {
        beeEl.dispatchEvent(new CustomEvent('bee:revive', { bubbles: true }));
      }, 5000);
    },
  });
};

// ── 初期化 ──────────────────────────────────────────────────
export default {
  init() {
    // タッチデバイスはビームのみ無効（蜂クリックは有効）
    const hasPointer = !window.matchMedia('(pointer: coarse)').matches;

    if (hasPointer) {
      document.addEventListener('click', (e) => {
        if (e.target.closest('.g-fixarea__bee, .p-top-contact__bee')) return;
        shoot(e.clientX, e.clientY);
      });
    }

    // 蜂クリック
    ['.g-fixarea__bee', '.p-top-contact__bee'].forEach((sel) => {
      const el = document.querySelector(sel);
      if (!el) return;

      el.style.cursor = 'crosshair';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        gsap.killTweensOf(el);
        explode(el);
      });
    });
  },
};
